/*
  *******************
      注册全局组件
  *******************
*/
import Vue from 'vue'

import Link from '../components/link.vue'
import xsyLogo from '../components/xsy-logo.vue'
import layout from '../components/layout/index.vue'
import layoutHeader from '../components/layout/layout-header.vue'

Vue.component('Link', Link)
Vue.component('xsyLogo', xsyLogo)
Vue.component('layout', layout)
Vue.component('layoutHeader', layoutHeader)



// WEBPACK FOOTER //
// ./src/utils/components.js